import React, { useEffect, useState } from 'react';
import { formatCurrency } from 'src/lib/catalog';
import { useFetch } from 'src/lib/FetchContext';

export const BidDetails = ({ item }) => {
  if(!item) return null;
  const { fetch } = useFetch();
  const [loading, setLoading] = useState(false);
  const [shipping, setShipping] = useState(null);

  const fetchData = async () => {
    const result = await(await fetch('/api/bids/estimate-shipping', {
      credentials: 'include',
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        auctionId: item.AuctionID,
        lotNumber: item.LotNumber,
      }),
    })).json();
    if(!result.success) {
      setShipping(null);
    } else {
      if(result.counts.oItem > 0 || result.counts.unknow > 0) {
        setShipping(0);
      }
      setShipping(result.estimates.shipping + result.estimates.materials);
    }
    setLoading(false);
  };

  useEffect(() => {
    setLoading(true);
    fetchData().catch((err) => {
      console.error(err);
      setLoading(false);
      setShipping(null);
    });
  }, []);


  if(loading || shipping === null) {
    return null;
  }

  return (<div>
    <p className={'text-zinc-900'}>
      All sales are subject to buyer's premium, sales tax, and credit card fees.&nbsp;
    </p>
    <p className={'text-zinc-900'}>
      Estimated shipping, handling, and materials: {
        shipping === 0
          ? 'Shipping cannot be calculated on this item, but will be included in your total.'
          : formatCurrency(shipping)
      }
    </p>
  </div>);
};


